import { createIcons, icons } from 'lucide';
createIcons({ icons });
